import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

export const StripeReturn: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verificationSessionId = searchParams.get('session');
    
    if (!verificationSessionId) {
      setStatus('error');
      setMessage('Session de vérification non trouvée');
      return;
    }

    // Vérifier le statut de la session auprès du backend
    checkVerificationStatus(verificationSessionId);
  }, [searchParams]);

  const checkVerificationStatus = async (sessionId: string) => {
    try {
      const response = await axios.get(
        `https://seal-app-og4c6.ondigitalocean.app/api/stripe/verify-status/${sessionId}`
      );

      if (response.data.success && response.data.verified) {
        setStatus('success');
        setMessage('Votre identité a été vérifiée avec succès !');
      } else {
        setStatus('error');
        setMessage('La vérification a échoué. Veuillez réessayer.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Erreur lors de la vérification. Contactez le support.');
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        {status === 'loading' && (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-semibold mb-2">Vérification en cours...</h2>
            <p className="text-gray-600">Veuillez patienter pendant que nous vérifions votre identité.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="text-green-500 text-6xl mb-4">✓</div>
            <h2 className="text-2xl font-semibold text-green-700 mb-2">Vérification réussie !</h2>
            <p className="text-gray-700 mb-6">{message}</p>
            <p className="text-gray-600 mb-6">
              Vous pouvez maintenant retourner à l'application CoKilo pour continuer votre inscription.
            </p>
            <button
              onClick={() => window.close()}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
            >
              Fermer cette fenêtre
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-red-500 text-6xl mb-4">✗</div>
            <h2 className="text-2xl font-semibold text-red-700 mb-2">Échec de la vérification</h2>
            <p className="text-gray-700 mb-6">{message}</p>
            <p className="text-gray-600 mb-6">
              Retournez à l'application et réessayez la vérification d'identité.
            </p>
            <div className="space-y-3">
              <button
                onClick={() => window.close()}
                className="w-full bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700"
              >
                Fermer cette fenêtre
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};